// React
import { FC, ReactNode, useContext, useState } from 'react'

// Libraries
import { Outlet } from 'react-router-dom'

// Misc
import { useMediaQuery } from 'hooks'

// Components
import * as Styled from './styled'
import { Aligner, Subtitle, Tabs } from 'heeds-ds'
import { ThemeContext } from 'styled-components'

// Constants
const STEPS = ['Modelos de anamneses']

export interface IAthleteOutletContext {
  id: string
  isEditing: boolean
  navigateToNextTab: (to?: string) => void
  navigateToPreviousTab: (to?: string) => void
  blockNavigation: (to?: string) => void
}

type Props = {
  children?: ReactNode | ReactNode[]
}

const LibraryLayout: FC<Props> = ({ children }) => {
  const theme = useContext(ThemeContext)
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.desktop}px)`)
  const isTablet = useMediaQuery(`(min-width: ${theme.breakpoints.tablet}px)`)

  const [selectedTab, setSelectedTab] = useState(STEPS[0])

  return (
    <Styled.Container>
      {isTablet && (
        <Aligner gap="4rem" flex="column">
          {isDesktop && <Subtitle weight={700}>Biblioteca</Subtitle>}

          <Tabs
            active={selectedTab}
            distanceOfBar="1.6rem"
            fontSize="copy3"
            setActive={(tab) => tab === STEPS[0] && setSelectedTab(tab)}
            tabs={STEPS}
            margin="0"
            padding="0"
          />
        </Aligner>
      )}
      <Styled.Content>{children || <Outlet />}</Styled.Content>
    </Styled.Container>
  )
}

export default LibraryLayout
